import {FireInTheHole2} from "../../FireInTheHole2";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {FITH2Helper} from "../../utils/FITH2Helper";

export class FreespinOutroPresentation implements FlowStatePresentation {
    name: string = "FreespinOutroPresentation";
    private _flowStateController: FlowStateController;

    shouldRun(): boolean {
        return !FireInTheHole2.model.isNormal && FireInTheHole2.model.isNextNormal;
    }

    start(controller: FlowStateController): void {
        this._flowStateController = controller;
        const tl = FireInTheHole2.freespinOutro.show(() => this.complete(), FireInTheHole2.apiPlugin.isReplay);
    }

    public complete():void {
        FireInTheHole2.freespinReelArea.hide();
        FireInTheHole2.reelFrame.show();
        this._flowStateController.finish();
        FireInTheHole2.keypadPlugin.setZeroBetSpinCounter(-1);
        FireInTheHole2.keypadPlugin.setWin(FireInTheHole2.model.gameData.accumulatedRoundWin, true, FITH2Helper.isWinBelowStake());
        FireInTheHole2.keypadPlugin.show();
    }
}